module.exports = __webpack_public_path__ + "img/space-suit.97414ba2.svg";